import Head from "next/head";
import { useRouter } from "next/router";
import { useMemo } from "react";
function normalizeScripts(scripts) {
  return safeParseJsonLd(scripts);
}
function safeParseJsonLd(scripts) {
  if (!scripts) return [];

  if (Array.isArray(scripts)) return scripts;

  if (typeof scripts !== "string") return [scripts];

  try {
    const parsed = JSON.parse(scripts);
    return Array.isArray(parsed) ? parsed : [parsed];
  } catch (firstError) {
    try {
      const cleaned = scripts
        // يشيل line breaks الحقيقية
        .replace(/\r?\n/g, " ")
        // يشيل comma قبل } أو ]
        .replace(/,\s*}/g, "}")
        .replace(/,\s*]/g, "]")
        .trim();

      const parsed = JSON.parse(cleaned);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (secondError) {
      console.error("Invalid JSON-LD even after cleaning:", secondError);
      return [];
    }
  }
}
function renderJsonLdTag(payload, idx) {
  try {
    return (
      <script
        key={idx}
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(payload),
        }}
      />
    );
  } catch (e) {
    console.warn("Invalid JSON-LD:", e);
    return null;
  }
}

const baseUrl = "https://contact.eg";

const PageHead = ({ title, description, scripts }) => {
  const router = useRouter();

  const { asPath, locale } = router;
  const normalizedScripts = useMemo(() => {
    return normalizeScripts(scripts);
  }, [scripts]);

  const cleanPath = useMemo(() => asPath?.split("?")[0] || "/", [asPath]);

  const corePath = useMemo(() => {
    if (!cleanPath || cleanPath === "/") return "/";
    if (cleanPath === "/ar" || cleanPath === "/en") return "/";

    const match = cleanPath.match(/^\/(ar|en)(\/.*)$/);
    if (match) {
      return match[2];
    }

    return cleanPath;
  }, [cleanPath]);

  const arUrl = useMemo(
    () => `${baseUrl}${corePath === "/" ? "/" : corePath}`,
    [corePath],
  );

  const enUrl = useMemo(
    () => `${baseUrl}${corePath === "/" ? "/en" : `/en${corePath}`}`,
    [corePath],
  );

  const canonicalUrl = useMemo(() => {
    return locale === "en" ? enUrl : arUrl;
  }, [locale, arUrl, enUrl]);

  return (
    <Head>
      <title>{title || "Contact - Leading Financing Services in Egypt"}</title>

      <meta
        name="description"
        content={
          description ||
          "Explore Contact's range of financing solutions, from auto loans to home financing. Discover how our flexible options support your financial needs with reliable services"
        }
      />

      <link rel="canonical" href={canonicalUrl} />

      <link rel="alternate" hrefLang="ar" href={arUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={arUrl} />

      {normalizedScripts.map((script, idx) => renderJsonLdTag(script, idx))}
    </Head>
  );
};

export default PageHead;
